import * as Types from "./action.types";
import * as Models from "../models/index";

import * as Login from "./creators/login";
import * as PwdRecovery from "./creators/pwd.recovery";
import * as PwdExpired from "./creators/pwd.reset";
import * as PwdValidate from "./creators/pwd.validate";
import * as PwdSecurity from "./creators/pwd.security";
import * as PwdChange from "./creators/pwd.change";

export const loadInitialData = (data: Models.InitialData) => ({
  type: Types.LOAD_INITIAL_DATA,
  payload: data as Types.LOAD_INITIAL_DATA_PAYLOAD,
});

export const changeBrowserRegistration = (isBrowserRegistered: boolean) => ({
  type: Types.CHANGE_BROWSER_REGISTRATION,
  payload: isBrowserRegistered as Types.CHANGE_BROWSER_REGISTRATION_PAYLOAD,
});

export const resetScreenSize =
  () => (d: Function, gs: () => Models.StoreState) => {
    var mobileMode = window.innerWidth < 700;
    if (gs().shell.isMobileMode !== mobileMode)
      d({
        type: Types.REFRESH_APP_WINDOW_SIZE,
        payload: {
          isMobileMode: mobileMode,
        } as Types.REFRESH_APP_WINDOW_SIZE_PAYLOAD,
      });
  };

export const showForgotUserMessage = () => ({
  type: Types.SHOW_FORGOT_USERNAME_MESS,
});
export { Login, PwdRecovery, PwdValidate, PwdExpired, PwdChange, PwdSecurity };
